<div class="box">

  @if (statesService.states.started) {
    <div class="age">
      <h2>Dein@if (simulation.pet.type === 'cat') {
        <span>e</span>
      }
      {{getPetName()}}
      ist
      {{formatAge()}}
      @if (formatAge() == 1) {
        <span>Tag</span>
      }
      @if (formatAge() != 1) {
        <span>Tage</span>
      }
    alt. </h2>
  </div>
}

</div>
